import { useBraze } from '@components/Braze';
import { useEffect, useRef } from 'react';
import { useCompany } from '@/hooks/useCompany';
import { useCompanyLimits } from '@/hooks/useCompanyLimits';

export const BrazeLogCompanyViewed = ({ companyId }: { companyId: string }) => {
  const { logCustomEvent } = useBraze();
  const logged = useRef(false);
  const { data: company, status } = useCompany(companyId);
  const limits = useCompanyLimits();

  useEffect(() => {
    if (logged.current || status !== 'success') {
      return;
    }
    logged.current = true;
    const companyData = company?.data;
    logCustomEvent('company_viewed', {
      companyIndustry: companyData?.info?.data?.industry.name,
      companyMarket: companyData?.exchange_symbol,
      companyName: companyData?.name,
      companyTicker: companyData?.unique_symbol,
      viewsCountBillingPeriod: limits.views,
      viewsLeftBillingPeriod: limits.limit - limits.views,
      billingPeriodResetDate: limits.resetDate,
    });
  }, [
    company?.data,
    limits.limit,
    limits.resetDate,
    limits.views,
    logCustomEvent,
    status,
  ]);

  return null;
};
